import React, { VFC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip'
import { useTranslation } from '@Globals/Translations'

export const FreeDeliveryChip: VFC<ChipProps> = ({ size = 'medium' }) => {
  const { t } = useTranslation()

  return (
    <Chip
      fadedBackground
      size={size}
      uppercase
    >
      {t('common:FREE_DELIVERY')}
    </Chip>
  )
}
